export default __webpack_public_path__ + "static/media/TOYOTA.db4e7ddb.png";